import React, { useEffect, useState } from 'react'
import {
  MdErrorOutline,
  MdSearch,
  MdOutlineTag,
  MdOutlineCalendarMonth,
  MdOutlinePhone,
  MdOutlineHome,
  MdOutlineCake,
  MdOutlineMonitorWeight,
  MdOutlineStickyNote2,
  MdOutlineComment,
} from 'react-icons/md'
import { FaClinicMedical } from 'react-icons/fa'
import { useToast } from '../../controls/Toast/ToastService'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { IoMdOpen } from 'react-icons/io'
import { Link, useParams } from 'react-router-dom'
import Paging from '../../controls/Paging'
import Input from '../../controls/Input'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { PAGE_SIZE } from '../../../configurations/initUrls'
import useDebounce from '../../../configurations/commonlib/useDebounce'
import moment from 'moment'
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus'
import Datepicker from 'react-tailwindcss-datepicker'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
const NEXT_MONTH = new Date();
NEXT_MONTH.setMonth(NEXT_MONTH.getMonth() - 1);
//const TODAY = new Date();


export default function GetAllConfirmed() {
  const { start, end } = useGlobalLoader()
  const [dateVal, setDateVal] = useState({
    startDate: NEXT_MONTH,
    endDate: new Date()
  });
  useEffect(() => {
    setSearch(pre => (
      {
        ...pre,
        FromDate: moment(new Date(dateVal.startDate)).format("MM/DD/YYYY"),
        ToDate: moment(new Date(dateVal.endDate)).format("MM/DD/YYYY")
      }))
  }, [dateVal])


  var date = new Date()
  const { userid } = useParams()
  const initValues = {
    UserId: userid,
    PageNo: 1,
    PageSize: PAGE_SIZE,
    SearchTerm: "",
    FromDate: moment(NEXT_MONTH).format("MM/DD/YYYY"),
    ToDate: moment(new Date()).format("MM/DD/YYYY"),
  }
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);


  useEffect(() => {
    setSearchDebounce(searchTerm)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  useEffect(() => {
    onSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDebounce])

  useEffect(() => {
    onSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.FromDate, search.ToDate])

  const OnPageChange = (e) => {
    setSearch({ ...search, PageNo: e })
    onSearchNew({
      UserId: search.UserId,
      PageNo: e,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm,
      FromDate: moment(new Date(dateVal.startDate)).format("MM/DD/YYYY"),
      ToDate: moment(new Date(dateVal.endDate)).format("MM/DD/YYYY"),
    })
  }

  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }

  const onSearch = () => {
    onSearchNew({
      UserId: search.UserId,
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: searchTerm,
      FromDate: search.FromDate,
      ToDate: search.ToDate,
    })
  }

  const onSearchNew = (search) => {
    GetAllConfirmed(search)
  }
  const GetAllConfirmed = (params) => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetAllConfirmed(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // three badges: status / source / type
  const renderBadges = (item) => (
    <div className="whitespace-nowrap flex items-center gap-1">
      <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
      <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
      <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
    </div>
  )

  return (
    <div className="flex flex-col">
      {/* filters */}
      <div className="flex flex-col sm:flex-row sm:space-x-3">
        <div className="w-full py-3">
          <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-gray-700">
            <MdOutlineCalendarMonth className="text-base text-brand-600" /> Date Range
          </label>
          <Datepicker
            popoverDirection='down'
            displayFormat="DD/MM/YYYY"
            readOnly={true}
            separator="to"
            primaryColor={"sky"}
            value={dateVal}
            onChange={newValue => setDateVal(newValue)}
            showShortcuts={true}
            inputClassName="outline-blue-400 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
          />
        </div>
        <div className="w-full py-3">
          <label className="mb-1 flex items-center gap-1.5 text-sm font-medium text-gray-700">
            <MdSearch className="text-base text-brand-600" /> Search
          </label>
          <Input
            Icon={<MdSearch className="text-lg text-gray-400" />}
            onChange={onSearchChange}
            placeholder="Search..."
          ></Input>
        </div>
      </div>

      <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData}>
        {!loding ? (
          userData.length > 0 ? (
            <>
              {/* ===== desktop table ===== */}
              <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 lg:block">
                <table className="w-full border-collapse text-left text-sm text-gray-500 rtl:text-right">
                  <thead>
                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><FaClinicMedical className="text-xs" /> Center</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> #</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">Patient</th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlinePhone className="text-sm" /> Phone</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineCake className="text-sm" /> Age/Wt</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineStickyNote2 className="text-sm" /> Note</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineComment className="text-sm" /> Comment</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineCalendarMonth className="text-sm" /> Date</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">
                        <span className="flex items-center gap-1"><MdOutlineHome className="text-sm" /> Address</span>
                      </th>
                      <th scope="col" className="px-3 py-3 font-semibold">Badges</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {userData.map((item, index) => (
                      <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                        <td className="text-nowrap px-3 py-2">{item.opdCenter.centerName}</td>
                        <td className="px-3 py-2 text-gray-500">{item.id}</td>
                        <td className="text-nowrap px-3 py-2 font-bold text-gray-800">
                          {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                        </td>
                        <td className="text-nowrap px-3 py-2">
                          {item.mobile
                            ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                            : "—"}
                        </td>
                        <td className="text-nowrap px-3 py-2">{item.age}/{item.weight}</td>
                        <td className="max-w-[120px] truncate px-3 py-2" title={item.note}>{item.note ? item.note : "N/A"}</td>
                        <td className="max-w-[120px] truncate px-3 py-2" title={item.acceptedWithComment}>{item.acceptedWithComment ? item.acceptedWithComment : "N/A"}</td>
                        <td className="text-nowrap px-3 py-2">{moment(item.onDate).format("DD/MMM/YYYY")}</td>
                        <td className="max-w-[140px] truncate px-3 py-2" title={item.patientAddress}>{item.patientAddress}</td>
                        <td className="whitespace-nowrap px-3 py-2">{renderBadges(item)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ===== mobile / tablet cards ===== */}
              <div className="space-y-2 lg:hidden">
                {userData.map((item, index) => (
                  <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <div className="font-bold text-gray-900">
                          {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                        </div>
                        <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500">
                          <span className="flex items-center gap-0.5"><MdOutlineTag className="text-sm" /> {item.id}</span>
                          <span className="flex items-center gap-0.5"><MdOutlineCake className="text-sm" /> {item.age} Y</span>
                          <span className="flex items-center gap-0.5"><MdOutlineMonitorWeight className="text-sm" /> {item.weight} Kg</span>
                        </div>
                        <div className="mt-0.5 flex items-center gap-1 text-xs text-gray-500">
                          <FaClinicMedical className="shrink-0 text-[10px]" />
                          <span className="truncate">{item.opdCenter.centerName}</span>
                        </div>
                      </div>
                      <span className="flex shrink-0 items-center gap-1 text-xs text-gray-400">
                        <MdOutlineCalendarMonth className="text-sm" />
                        {moment(item.onDate).format("DD/MMM/YYYY")}
                      </span>
                    </div>

                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                      <div className="flex items-center gap-1">
                        <MdOutlinePhone className="shrink-0 text-sm text-gray-400" />
                        {item.mobile
                          ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                          : "—"}
                      </div>
                      <div className="flex items-start gap-1">
                        <MdOutlineHome className="mt-0.5 shrink-0 text-sm text-gray-400" />
                        <span>{item.patientAddress}</span>
                      </div>
                      {item.note &&
                        <div className="flex items-start gap-1">
                          <MdOutlineStickyNote2 className="mt-0.5 shrink-0 text-sm text-gray-400" />
                          <span>{item.note}</span>
                        </div>}
                      {item.acceptedWithComment &&
                        <div className="flex items-start gap-1">
                          <MdOutlineComment className="mt-0.5 shrink-0 text-sm text-gray-400" />
                          <span>{item.acceptedWithComment}</span>
                        </div>}
                    </div>

                    <div className="mt-2">{renderBadges(item)}</div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Empty>No Items Found.</Empty>
          )
        ) : (
          <LoadingContainer />
        )}
      </Paging>
    </div>
  )
}